import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { AsyncProductSelect } from './function';

export const AsyncProductSelectFormField = FormFieldBlueprint.make({
  name: 'async-product-select',
  params: {
    field: async () =>
      createFormField({
        name: 'AsyncProductSelect',
        component: AsyncProductSelect,
      }),
  },
});
